import React, {useCallback, useState} from 'react'
import {UseTabs, UseTabsOptions} from './types'

export const useTabs = ({
  onChange,
  defaultActiveId,
  canChangeTab = true,
  onClick
}: UseTabsOptions): UseTabs => {
  const [activeId, setActiveId] = useState<string>(defaultActiveId)
  const onTabClick = useCallback(
    (id: string, e: React.MouseEvent) => {
      if (canChangeTab) {
        setActiveId(id)
        onChange(id, e)
      }
      onClick?.()
    },
    [setActiveId, onChange, canChangeTab]
  )
  return {activeId, onTabClick}
}
